<template>
    <div>
        <div class="header">
            <div class="step-ttl">سایر اطلاعات</div>
            <div class="h-border"></div>
            <div class="step">مرحله 4-4</div>
        </div>
        <div class="sub-header">
            <div class="step-ttl">
                نحوه مراجعه/ارتباط
            </div>
            <div class="h-border"></div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <input class="custom-input-button" type="checkbox" v-model="referralInfo.isFromAdvertising" value="false" id="ads">
                    <label for="ads">آگهی</label>
                </div>
            </div>
            <div class="col-md-12">
                <div class="form-group">

                    <label>
                        توضیح:
                    </label>
                    <input class="form-control" type="text" v-model="referralInfo.advertising">
                </div>
            </div>
            <div class="col-md-12">
                <div class="form-group">

                    <label>
                        مورخ:
                    </label>
                    <input class="form-control" type="text" placeholder="مورخ:1399/10/11" v-model="referralInfo.advertisingDate">
                </div>
            </div>

        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <input class="custom-input-button" type="checkbox" v-model="referralInfo.isFromOtherPerson" value="false" id="introduction">
                    <label for="introduction">معرفي افراد</label>
                </div>
            </div>
            <div class="col-md-12">
                <div class="form-group">
                    <label>
                        خانم/آقای:
                    </label>
                    <input class="form-control" type="text" placeholder="خانم/آقای:" v-model="referralInfo.referralPerson">
                </div>
            </div>
            <div class="col-md-12">
                <div class="form-group">
                    <input class="custom-input-button" type="checkbox" v-model="referralInfo.isOtherWays" value="false" id="acquaintance-other">
                    <label for="acquaintance-other">ساير</label>
                </div>
            </div>
            <div class="col-md-12">
                <div class="form-group">
                    <label>
                        توضیح:
                    </label>
                    <input class="form-control" type="text" v-model="referralInfo.otherWaysDescription">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <label class="d-block">
                        آيا با كاركنان این شرکت آشنايي و يا نسبتي داريد؟
                    </label>
                    <div class="d-inline-block">
                        <input class="custom-input-button" type="radio" v-model="referralInfo.hasRelationWithOtherEmployee" value="true" id="familar" @change="changeHasRelationWithOtherEmployee">
                        <label for="familar">بلی</label>
                    </div>
                    <div class="d-inline-block">

                        <input class="custom-input-button" type="radio" v-model="referralInfo.hasRelationWithOtherEmployee" value="false" id="not-familar" @change="changeHasRelationWithOtherEmployee">
                        <label for="not-familar">خیر</label>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="referralInfo.hasRelationWithOtherEmployee=='true'">
            <div class="col-md-12">
                <div class="form-group">
                    <label>لطفا" با ذكر  نام همكار ، توضيح دهيد:</label>
                    <input class="form-control" type="text" v-model="referralInfo.employeeName">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <label class="d-block">
                        لطفا" 3 نفر  ( بغير از بستگان درجه يك ) كه مي توانند شناخت خود را از خصوصيات ، يا توانايي حرفه اي شما دراختيار ما بگذارند را ذكر نمائيد:
                    </label>
                </div>
            </div>
        </div>
        <div :class="[index==1?'new-item':'','row']" v-for="(info, index) in relationInfos.filter(x => x.isFirstDegreeRelative === true)" :key="index">
            <div class="col-md-12">
                <div class="form-group">
                    <label>نام:</label>
                    <input type="text"
                           v-model="$v.relationInfos.$each[index].name.$model"
                           @input="$v.relationInfos.$each[index].name.$touch()"
                           :class="[$v.relationInfos.$each[index].name.$error && !$v.relationInfos.$each[index].name.required ?'error-input' :'','form-control']">
                    <span class="help-block" v-if="$v.relationInfos.$each[index].name.$error && !$v.relationInfos.$each[index].name.required">لطفا نام را وارد کنید.</span>
                </div>
            </div>
            <div class="col-md-12">
                <div class="form-group">
                    <label>نسبت:</label>
                    <input type="text"
                           v-model="$v.relationInfos.$each[index].relation.$model"
                           @input="$v.relationInfos.$each[index].relation.$touch()"
                           :class="[$v.relationInfos.$each[index].relation.$error && !$v.relationInfos.$each[index].relation.required ?'error-input' :'','form-control']">
                    <span class="help-block" v-if="$v.relationInfos.$each[index].relation.$error && !$v.relationInfos.$each[index].relation.required">لطفا نسبت را وارد کنید.</span>
                </div>
            </div>
            <div class="col-md-12">
                <div class="form-group">
                    <label>محل فعاليت:</label>
                    <input type="text"
                           v-model="$v.relationInfos.$each[index].workCompany.$model"
                           @input="$v.relationInfos.$each[index].workCompany.$touch()"
                           :class="[$v.relationInfos.$each[index].workCompany.$error && !$v.relationInfos.$each[index].workCompany.required ?'error-input' :'','form-control']">
                    <span class="help-block" v-if="$v.relationInfos.$each[index].workCompany.$error && !$v.relationInfos.$each[index].workCompany.required">لطفا محل فعاليت را وارد کنید.</span>
                </div>
            </div>
            <div class="col-md-12">
                <div class="form-group">
                    <label>سمت/نوع فعاليت:</label>
                    <input type="text"
                           v-model="$v.relationInfos.$each[index].post.$model"
                           @input="$v.relationInfos.$each[index].post.$touch()"
                           :class="[$v.relationInfos.$each[index].post.$error && !$v.relationInfos.$each[index].post.required ?'error-input' :'','form-control']">
                    <span class="help-block" v-if="$v.relationInfos.$each[index].post.$error && !$v.relationInfos.$each[index].post.required">لطفا سمت/نوع فعاليت را وارد کنید.</span>
                </div>
            </div>
            <div class="col-md-12">
                <div class="form-group">
                    <label>تلفن هاي تماس‌:</label>
                    <input type="text"
                           v-model="$v.relationInfos.$each[index].phoneNumber.$model"
                           @input="$v.relationInfos.$each[index].phoneNumber.$touch()"
                           :class="[$v.relationInfos.$each[index].phoneNumber.$error && !$v.relationInfos.$each[index].phoneNumber.required ?'error-input' :'','form-control']">
                    <span class="help-block" v-if="$v.relationInfos.$each[index].phoneNumber.$error && !$v.relationInfos.$each[index].phoneNumber.required">لطفا تلفن تماس را وارد کنید.</span>
                </div>
            </div>
        </div>
        <div class="sub-header">
            <div class="step-ttl">
                اطلاعات بستگان درجه یک
            </div>
            <div class="h-border"></div>

        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <label class="d-block">
                        لطفا نام دو نفر از اعضای خانواده  را جهت موارد اضطراری ذکر نمائید:
                    </label>
                </div>
            </div>
        </div>
        <div :class="[index==1?'new-item':'','row']" v-for="(info, index) in relationInfos.filter(x => x.isFirstDegreeRelative === false)" :key="'immediateRelative'+index">
            <div class="col-md-12">
                <div class="form-group">
                    <label>نام:</label>
                    <input type="text"
                           v-model="$v.relationInfos.$each[index+3].name.$model"
                           @input="$v.relationInfos.$each[index+3].name.$touch()"
                           :class="[$v.relationInfos.$each[index+3].name.$error && !$v.relationInfos.$each[index+3].name.required ?'error-input' :'','form-control']">
                    <span class="help-block" v-if="$v.relationInfos.$each[index+3].name.$error && !$v.relationInfos.$each[index+3].name.required">لطفا نام را وارد کنید.</span>
                </div>
            </div>
            <div class="col-md-12">
                <div class="form-group">
                    <label>نسبت:</label>
                    <input type="text"
                           v-model="$v.relationInfos.$each[index+3].relation.$model"
                           @input="$v.relationInfos.$each[index+3].relation.$touch()"
                           :class="[$v.relationInfos.$each[index+3].relation.$error && !$v.relationInfos.$each[index+3].relation.required ?'error-input' :'','form-control']">
                    <span class="help-block" v-if="$v.relationInfos.$each[index+3].relation.$error && !$v.relationInfos.$each[index+3].relation.required">لطفا نسبت را وارد کنید.</span>
                </div>
            </div>
            <div class="col-md-12">
                <div class="form-group">
                    <label>شماره تماس:</label>
                    <input type="text"
                           v-model="$v.relationInfos.$each[index+3].phoneNumber.$model"
                           @input="$v.relationInfos.$each[index+3].phoneNumber.$touch()"
                           :class="[$v.relationInfos.$each[index+3].phoneNumber.$error && !$v.relationInfos.$each[index+3].phoneNumber.required ?'error-input' :'','form-control']">
                    <span class="help-block" v-if="$v.relationInfos.$each[index+3].phoneNumber.$error && !$v.relationInfos.$each[index+3].phoneNumber.required">لطفا تلفن تماس را وارد کنید.</span>
                </div>
            </div>
        </div>
        <div class="sub-header">
            <div class="step-ttl">
                شغل مورد نظر
            </div>
            <div class="h-border"></div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <label>شغل/زمينه هاي همكاري موردنظر خود را نام ببريد:</label>
                    <input type="text"
                           v-model.trim="requestedJobInfo.typesOfCooperation"
                           @input="$v.requestedJobInfo.typesOfCooperation.$touch()"
                           :class="[$v.requestedJobInfo.typesOfCooperation.$error?'error-input' :'','form-control']">
                    <span class="help-block" v-if="$v.requestedJobInfo.typesOfCooperation.$error && !$v.requestedJobInfo.typesOfCooperation.required">لطفا شغل/زمينه هاي همكاري موردنظر خود را نام ببريد.</span>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <label>زمان آمادگي براي شروع كار:</label>
                    <input type="text"
                           v-model.trim="requestedJobInfo.readyForCooperationDate"
                           @input="$v.requestedJobInfo.readyForCooperationDate.$touch()"
                           placeholder="مثال:1399/11/11"
                           :class="[$v.requestedJobInfo.readyForCooperationDate.$error?'error-input' :'','form-control']">
                    <span class="help-block" v-if="$v.requestedJobInfo.readyForCooperationDate.$error && !$v.requestedJobInfo.readyForCooperationDate.required">لطفا زمان آمادگي براي شروع كار را وارد کنید.</span>
                </div>
            </div>
            <div class="col-md-12">
                <div class="form-group">
                    <label>ميزان حقوق درخواستی (ريال):</label>
                    <input type="text"
                           v-model.trim="requestedJobInfo.requestedSalary"
                           @input="$v.requestedJobInfo.requestedSalary.$touch()"
                           :class="[$v.requestedJobInfo.requestedSalary.$error?'error-input' :'','form-control']">
                    <span class="help-block" v-if="$v.requestedJobInfo.requestedSalary.$error && !$v.requestedJobInfo.requestedSalary.required">لطفا ميزان حقوق درخواستی (ريال) را وارد کنید.</span>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label class="d-block">
                        آيا امكان حضور در زمان خارج از وقت اداري را داريد؟
                    </label>
                    <div class="d-inline-block">
                        <input class="custom-input-button" type="radio" v-model="requestedJobInfo.canParticipateInOutOfOfficeHours" value="true" id="flexible">
                        <label for="flexible">بلی</label>
                    </div>
                    <div class="d-inline-block">

                        <input class="custom-input-button" type="radio" v-model="requestedJobInfo.canParticipateInOutOfOfficeHours" value="false" id="not-flexible">
                        <label for="not-flexible">خیر</label>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <p>
                    همچنين مي توانيد درصورت تمايل ، رزومه خود را پيوست نمائيد.

                </p>
            </div>
            <div class="col-md-12">
                <div class="form-group">
                    <input type="file" name="file" id="file" class="input-file" @change="clickToAttachFile($event)">
                    <label for="file" class="btn btn-tertiary js-labelFile">
                        <i class="ion-android-attach"></i>
                        <span class="js-fileName"><i class="avafont-attach"></i>بارگذاری فایل</span>
                    </label>
                </div>
                <div class="file-action-btn" v-if="cv.length>0">
                    <a href="javascript:void(0);"
                       class="remove_rowbtn"
                       @click="deleteCVFile()"
                       title="حذف فایل بارگذاری شده"><i class="avafont-close"></i></a>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <div class="d-inline-block">
                        <input class="custom-input-button" type="checkbox" name="agree-rules" value="agree" id="agree" checked="checked" disabled>
                        <label for="agree">اينجانب، اطلاعات درخواستي را با نهايت دقت ، كامل نمودم و صحت تمامي موارد درج شده را تاييد مي كنم ، درصورت وجود هرگونه مغايرت در اطلاعات ارائه شده ، شركت را مجاز به فسخ قرارداد دانسته و حق هرگونه اعتراض را از خود سلب می نمايم. </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <p class="blue"> از ابراز تمايل شما براي همكاري با شركت فناوران آواسیس متشكريم.</p>

            </div>
        </div>
    </div>
</template>
<script>
    import { required, requiredIf } from "vuelidate/lib/validators";
    export default {
        data() {
            return {
                referralInfo: {
                    isFromAdvertising: false,
                    advertising: "",
                    advertisingDate: "",
                    isFromOtherPerson: false,
                    isOtherWays: false,
                    otherWaysDescription: "",
                    referralPerson: "",
                    hasRelationWithOtherEmployee: false,
                    employeeName: ""
                },
                relationInfos: [
                    {
                        name: "",
                        relation: "",
                        workCompany: "",
                        post: "",
                        phoneNumber: "",
                        isFirstDegreeRelative: true
                    },
                    {
                        name: "",
                        relation: "",
                        workCompany: "",
                        post: "",
                        phoneNumber: "",
                        isFirstDegreeRelative: true
                    },
                    {
                        name: "",
                        relation: "",
                        workCompany: "",
                        post: "",
                        phoneNumber: "",
                        isFirstDegreeRelative: true
                    },
                    {
                        name: "",
                        relation: "",
                        workCompany: "-",
                        post: "-",
                        phoneNumber: "",
                        isFirstDegreeRelative: false
                    },
                    {
                        name: "",
                        relation: "",
                        workCompany: "-",
                        post: "-",
                        phoneNumber: "",
                        isFirstDegreeRelative: false
                    }
                ],
                requestedJobInfo: {
                    typesOfCooperation: "",
                    readyForCooperationDate: "",
                    canParticipateInOutOfOfficeHours: false,
                    requestedSalary: null
                },
                cv: ""
            }
        },
        validations: {
            referralInfo: {
                referralPerson: {
                    required: requiredIf(function () {
                        return this.referralInfo.isFromOtherPerson == 'true'
                    })
                },
                employeeName: {
                    required: requiredIf(function () {
                        return this.referralInfo.hasRelationWithOtherEmployee == 'true'
                    })
                },
                otherWaysDescription: {
                    required: requiredIf(function () {
                        return this.referralInfo.isOtherWays == 'true'
                    })
                }
            },
            relationInfos: {
                $each: {
                    name: { required },
                    relation: { required },
                    workCompany: { required },
                    post: { required },
                    phoneNumber: { required }
                }
            },
            requestedJobInfo: {
                typesOfCooperation: { required },
                readyForCooperationDate: { required },
                requestedSalary: { required }
            },
            cv: "",
            form: ['referralInfo', 'relationInfos', 'requestedJobInfo', 'cv']
        },
        methods: {
            validate() {
                this.$v.form.$touch();
                var isValid = !this.$v.form.$invalid
                this.$emit('on-validate', this.$data, isValid)
                return isValid
            },
            changeHasRelationWithOtherEmployee() {
                this.referralInfo.employeeName = '';
            },
            clickToAttachFile(element) {
                var files = document.getElementById('file').files;
                var $label = document.querySelector('.js-labelFile');
                var labelVal = document.querySelector('.js-labelFile').innerText;
                var fileName = '';
                if (element.target.value) {
                    fileName = element.target.value.split('\\').pop()
                };
                if (fileName) {
                    $label.classList.add('has-file');
                    $label.innerText = fileName;
                } else {
                    $label.classList.remove('has-file');
                    $label.innerText = labelVal;
                };
                if (files.length > 0) {
                    this.getBase64(files[0]).then(r => {
                        this.cv = r.split(',')[1];
                    }).catch(e => {
                        this.$swal({
                            position: 'center-center',
                            icon: 'error',
                            text: 'خطا در بارگذاری! لطفا مجددا امتحان نمایید.',
                            showConfirmButton: false,
                            timer: 8000
                        });
                    });
                }
            },
            getBase64(file) {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = error => reject(error);
                });
            },
            deleteCVFile() {
                document.getElementById("file").value = "";
                document.querySelector('.js-labelFile').classList.remove('has-file');
                document.querySelector('.js-labelFile').innerHTML = '<i class="ion-android-attach"></i><span class="js-fileName"><i class="avafont-attach"></i>بارگذاری فایل</span>';
                this.cv = "";
            }
        }
    }
</script>